import * as React from 'react'
import { Currency } from '../../../../../../../components/Currency'

interface Props {
  enteredQuantity: number | null
  expectedQuantity: number | null
  purchasePrice: number | null
}

export const AuditCostDiscrepancy = (props: Props) => {
  const { enteredQuantity, expectedQuantity, purchasePrice } = props
  const stringDiscrepancy = ((enteredQuantity || 0) - (expectedQuantity || 0)).toFixed(4)
  const discrepancyAmount = parseFloat(stringDiscrepancy)
  const cost = discrepancyAmount * (purchasePrice || 0)

  let spanClassName: string
  if (!enteredQuantity || discrepancyAmount === 0) {
    spanClassName = 'text-muted'
  } else if (discrepancyAmount < 0) {
    spanClassName = 'text-danger'
  } else {
    spanClassName = 'text-success'
  }

  return (
    <span className={spanClassName}>
      {enteredQuantity === null ? '-' : <Currency centValue={cost} />}
    </span>
  )
}
